<template>
  <!-- 路桥首页 -->
  <div class="road-home">
    <div class="laborers">
      <statistic :data-list="warnList"/>
    </div>
    <div class="command">
      <div class="common-command">
        <div class="normal-command">
          <employee-collection :default-list="['00010001', '00020001']"/>
        </div>
        <div class="data-statistic">
          <laborers-site-rank/>
        </div>
      </div>
      <div class="task-command">
        <laborers-type/>
      </div>
    </div>
    <div class="statistics">
      <div class="statistics-left">
        <laborers-yesterday-rank/>
      </div>
      <div class="statistics-right">
        <warn-list/>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import EmployeeCollection from "@/components/h5/board/CEmployeeCollection.vue";
import Statistic from "@/views/h5/luqiao/home/sichuanluqiao/CStatistic.vue";
import WarnList from "@/views/h5/luqiao/home/sichuanluqiao/CWarnList.vue";
import LaborersSiteRank from "@/views/h5/luqiao/home/sichuanluqiao/LaborersSiteRank.vue";
import LaborersType from "@/views/h5/luqiao/home/sichuanluqiao/LaborersType.vue";
import LaborersYesterdayRank from "@/views/h5/luqiao/home/sichuanluqiao/LaborersYesterdayRank.vue";
import commonApi from "@/api/commonApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "RoadHome",
  components: {
     EmployeeCollection, Statistic, WarnList, LaborersSiteRank, LaborersType, LaborersYesterdayRank
  },
  data() {
    return {
      warnList: [],
      // 待办任务数据（原始数据）
      scrollTimer: null,
      isAutoScrolling: true,

      itemHeight: 64, // 单个任务项高度
    };
  },
  
  computed: {
    // 自动复制两份数据用于无缝滚动
    taskList() {
      // 如果原始数据为空，返回空数组
      if (!this.originalTaskList || this.originalTaskList.length === 0) {
        return [];
      }
      // 复制两份数据，实现无缝循环
      return [...this.originalTaskList, ...this.originalTaskList];
    },
  },

  mounted() {
    commonApi.luqiaoHomeStatistic().then(list => this.warnList = list);
  },
  
  watch: {
  },

  created() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "../../../../components/h5/board/common";
.road-home{
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
  //background: #f5f7fa;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  --border-radius: 12px;
  --card-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  --card-shadow-hover: 0 4px 16px 0 rgba(0, 0, 0, 0.12);
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  /* 美化滚动条 */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
  
  .laborers{
  }
  
  .command{
    flex: 1;
    min-height: 400px;
    display: flex;
    gap: 20px;
    overflow: hidden;
    
    .common-command{
      width: 20%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      flex: 1;
      
      .normal-command{
        background: #FFF;
        padding: 20px;
        box-shadow: var(--card-shadow);
        border-radius: var(--border-radius);
        transition: var(--transition);
        
        &:hover{
          box-shadow: var(--card-shadow-hover);
        }
        

      }
      
      .data-statistic{
        padding: 20px;
        background: #FFF;
        box-shadow: var(--card-shadow);
        border-radius: var(--border-radius);
        flex: 1;
        min-height: 200px;
        transition: var(--transition);
        &:hover{
          box-shadow: var(--card-shadow-hover);
        }
      }
    }
    
    .task-command{
      width: 30%;
      background: #FFF;
      box-shadow: var(--card-shadow);
      border-radius: var(--border-radius);
      padding: 20px;
      display: flex;
      flex-direction: column;
      transition: var(--transition);
      box-sizing: border-box;
      &:hover{
        box-shadow: var(--card-shadow-hover);
      }
      

    }
  }
  
  .statistics{
    height: 280px;
    display: flex;
    gap: 20px;
    flex-shrink: 0;
    
    .statistics-left{
      flex: 1;
      background: #FFF;
      border-radius: var(--border-radius);
      box-shadow: var(--card-shadow);
      transition: var(--transition);
      box-sizing: border-box;
      padding: 20px;
      &:hover{
        box-shadow: var(--card-shadow-hover);
      }
    }
    
    .statistics-right{
      padding: 20px;
      width: 400px;
      background: #FFF;
      border-radius: var(--border-radius);
      box-shadow: var(--card-shadow);
      transition: var(--transition);
      
      &:hover{
        box-shadow: var(--card-shadow-hover);
      }
    }
  }
}

/* 动画效果 */
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes ripple {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}
</style>